// extracted by mini-css-extract-plugin
module.exports = {"editScreen":"Details_Edit_editScreen__3K2t_","DefaultInputForm":"Details_Edit_DefaultInputForm__2OqLr","ErrorInputForm":"Details_Edit_ErrorInputForm__1Gl4T"};